import { graphql } from '@/gql/codegen/gql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

export const OVERWRITE_REFLECTION_MUTATION = graphql(/* GraphQL */ `
  mutation EmbaOverwriteReflection($input: OverwriteReflectionMutationInput!) {
    embaOverwriteReflection(input: $input) {
      embaUserReflectionResult {
        id
        reflection
      }
    }
  }
`);

export const useOverwriteReflectionMutation = (
  userAttendanceSlug: string,
  lessonSlug: string,
) => {
  const [
    overwriteReflectionMutation,
    {
      error: overwriteReflectionMutationError,
      loading: overwriteReflectionMutationLoading,
    },
  ] = useMutation(OVERWRITE_REFLECTION_MUTATION);

  const overwriteReflection = useCallback(
    async (overwrittenUserReflection: string): Promise<void> => {
      await overwriteReflectionMutation({
        variables: {
          input: {
            embaUserAttendanceSlug: userAttendanceSlug,
            embaCourseLessonSlug: lessonSlug,
            overwrittenUserReflection,
          },
        },
      });
    },
    [userAttendanceSlug, lessonSlug, overwriteReflectionMutation],
  );

  return {
    overwriteReflection,
    overwriteReflectionMutationError,
    overwriteReflectionMutationLoading,
  };
};
